import styled from 'styled-components'
import { css, media, sizes } from 'styles'
import StyledUserThumbHorizontal from 'components/UserThumb/UserThumbHorizontal/StyledUserThumbHorizontal'

const StyledHome = styled.div`
  .bottom {
    display: flex;
    justify-content: space-between;
  }

  .left {
    display: flex;
    margin-right: 4rem;
    ${p => {
      const contentWidth = window.innerWidth * 0.8 //20% for sidebar
      const chatWidth = document.body.className.match('chat-open') ? 300 : 50
      const bannerWidth = p.gold ? 0 : 300
      const whiteSpace = 60 + 40 // 60 for padding; 40 for margin-right
      const columns = (contentWidth - chatWidth - bannerWidth - whiteSpace) / 210 //210 for thumb width

      if (columns < 3) {
        return css`
          @media (min-width: ${sizes.mobile}px) {
            ${StyledUserThumbHorizontal}:nth-child(n+${columns < 2 ? 4 : 7}) {
              display: none;
            }
          }
        `
      }
    }}
  }

  .right {
    flex: 1;
    max-width: 300px;
    display: ${p => (p.gold ? 'none' : 'flex')};
    align-items: flex-end;
  }

  .mobileOnly {
    display: none;
  }

  ${media.mobile`
    .header.mobileOnly {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1rem;

      a {
        display: inline-flex;
        align-items: center;
      }
    }
    .bottom {
      margin-top: 3rem;
      flex-direction: column;
    }
    .left {
      margin: 0;
      display: flex;
      > div {
        flex: 1;
      }
      .users {
        max-height: 50rem;
        flex-flow: column wrap;
      }
      ${StyledUserThumbHorizontal} {
        width: 50%;
        box-sizing: border-box;
        padding-right: 2rem;

        &:nth-child(9) {
          display: none;
        }
      }
    }
    .right {
      align-self: center;
    }
  `}
  @media (max-width: 600px) {
    .left {
      .users {
        max-height: none;
      }
      ${StyledUserThumbHorizontal} {
        width: 30rem;
        padding: 0;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
`

export default StyledHome
